const whatsappNumber = '917838101836';

export const WHATSAPP_URL = `https://wa.me/${whatsappNumber}`;
export const API_URL = process.env.REACT_APP_API_URL || '';

// Google Play listing for the Android app. Set REACT_APP_ANDROID_APP_URL, or edit the fallback below.
export const ANDROID_APP_URL =
  process.env.REACT_APP_ANDROID_APP_URL ||
  'https://play.google.com/store/apps/details?id=com.delhi36.f2k';

// App Store listing for the iOS app. Set REACT_APP_IOS_APP_URL, or edit the fallback below.
export const IOS_APP_URL =
  process.env.REACT_APP_IOS_APP_URL ||
  'https://apps.apple.com/app/id6789470991';
